'use client'
import HeroCard from '@/components/Cards/HeroCard'
import { Heading } from '@/components/Common'
import React from 'react'
import { Pagination, Autoplay } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css'
import 'swiper/css/pagination'
import { NewsArticle } from '@/models/news.model'

const FeaturedSection = ({ newsList = [] }: { newsList: NewsArticle[] }) => {
  return (
    <section className="container mx-auto mt-4">
      <Heading>Nổi bật</Heading>
      <div className="hero-card-slider">
        <Swiper
          modules={[Pagination, Autoplay]}
          spaceBetween={16}
          slidesPerView={2}
          pagination={{
            clickable: true,
            dynamicBullets: true,
          }}
          autoplay={{
            delay: 10000,
            disableOnInteraction: false,
          }}
          breakpoints={{
            640: { slidesPerView: 2 },
            768: { slidesPerView: 3 },
            1024: { slidesPerView: 4 },
          }}
        >
          {newsList.map((item) => (
            <SwiperSlide key={item.id}>
              <HeroCard
                title={item.title}
                categoryName={item.categoryName}
                categoryId={item.categoryId}
                imageUrl={item.imageUrl}
                link={item.slug}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  )
}

export default FeaturedSection
